module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-header"
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popupInner"
  }, [(_vm.hasBasicAuth && !_vm.isAuthorized) ? _c('PopupForms', {
    on: {
      "signup": function($event) {
        _vm.justSignUp = true
      }
    }
  }) : _vm._e(), (_vm.justSignUp) ? _c('modal-window', {
    attrs: {
      "slot": "modal",
      "grey": true
    },
    on: {
      "close": _vm.closeModalConfirmEmail
    },
    slot: "modal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.modalTextHeader))]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Вам на почту направлено уведомление для подтверждения электронной почты, \nбез этого некоторые функции ЦОПП не будут доступны. Спасибо!")]), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('ExtButton', {
    attrs: {
      "color": "default",
      "size": "medium"
    },
    on: {
      "click": _vm.closeModalConfirmEmail
    }
  }, [_vm._v("Ок")])], 1)]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77c3c463","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/specialContents/authPopups/AuthPopups.vue
// module id = 1249911c21e99bf93bab
// module chunks = 18